import React from "react";
import "react-datepicker/dist/react-datepicker.css";

import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/auth/Login";
import DefaultLayout from "./components/layout/DefaultLayout";
import Dashboard from "./pages/dashboard/Dashboard";
import Error404 from "./components/Error404";
import Error500 from "./components/Error500";
import AuthProtect from "./protect/AuthProtect";
import Bikes from "./pages/bikes/Bikes";
import Categories from "./pages/bike-section/Categories/Categories";
import Brands from "./pages/bike-section/Brands/Brands";
import Budget from "./pages/bike-section/Budget/Budget";
import Fueltype from "./pages/bike-section/Fueltype/Fueltype";
import AddBikes from "./pages/bikes/AddBikes";
import EditBikes from "./pages/bikes/EditBikes";
import BikesInquiry from "./pages/BikesInquiry/BikesInquiry";
import Leadmanagement from "./pages/Leadmanagement";

const App = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<Error404 />} path={`/404`} />
      <Route element={<Error500 />} path={`/500`} />

      <Route path="/admin/login" element={<Login />} />

      {/* Default fallback route */}
      <Route path="*" element={<Navigate to="/404" />} />

      {/* Protected Routes */}
      <Route element={<AuthProtect />}>
        <Route element={<DefaultLayout />}>
          <Route path="/" element={<Navigate to="/admin/dashboard" />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/bikes/history" element={<Bikes />} />
          <Route path="/admin/bikes/add" element={<AddBikes />} />
          <Route path="/admin/bikes/edit/:id" element={<EditBikes />} />

          <Route path="/admin/categories" element={<Categories />} />
          <Route path="/admin/leadmanagement" element={<Leadmanagement />} />
          <Route path="/admin/brands" element={<Brands />} />
          <Route path="/admin/budget" element={<Budget />} />
          <Route path="/admin/fueltype" element={<Fueltype />} />

          <Route path="/admin/bikes_inquiry" element={<BikesInquiry />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
